import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { PulseLoader } from 'react-spinners';

const InvitePage = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const type = searchParams.get('type'); 

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const confirmInvitation = async () => {
      try {
        let endpoint = '';

        if (type === 'hunter') {
          endpoint = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/api/hunter/confirm-invitation';
        } else if (type === 'broker') {
          endpoint = 'https://alienrealty-backend-e9f2c9grecgjcjbz.centralus-01.azurewebsites.net/api/realtor/confirm-invitation';
        } else {
          setMessage('Tipo de invitación no válido.');
          setLoading(false);
          return;
        }

        const response = await axios.get(endpoint, { params: { code } });

        setSuccess(true);
        setMessage(response.data);
      } catch (error: any) {
        setSuccess(false);
        setMessage(
          error.response?.data || 'Ocurrió un error al confirmar la invitación.'
        );
      } finally {
        setLoading(false);
      }
    };

    if (code) {
      confirmInvitation();
    } else {
      setMessage('Código de invitación no válido.');
      setLoading(false);
    }
  }, [code, type]); 

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#fff',
        margin: 0,
        padding: '0 1rem',
      }}
    >
      <div
        style={{
          padding: '2rem 3rem',
          backgroundColor: '#fff',
          borderRadius: '12px',
          textAlign: 'center',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '100%',
          color: '#333',
          fontFamily: 'Arial, sans-serif',
          transition: 'all 0.3s ease',
        }}
      >
        <h2
          style={{
            fontSize: '2rem',
            marginBottom: '1rem',
            fontWeight: '700',
            color: '#4A90E2',
          }}
        >
          Confirmación de Invitación
        </h2>
        {loading ? (
          <div>
            <p style={{ fontSize: '1.2rem', color: '#888' }}>Procesando invitación...</p>
            <div
              style={{
                marginTop: '1rem',
                paddingTop: '1rem',
              }}
            >
              <PulseLoader
                color="#4A90E2"
                loading={loading}
                size={15}
                margin={4}
              />
            </div>
          </div>
        ) : (
          <p
            style={{
              color: success ? '#34d399' : '#f87171',
              fontSize: '1.1rem',
              fontWeight: '600',
              textTransform: 'uppercase',
              padding: '1rem',
              backgroundColor: success ? '#e6fffa' : '#fff5f5',
              borderRadius: '8px',
              marginTop: '1rem',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease',
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default InvitePage;
